import { User } from "@firebase/auth";
import React, { createContext, useEffect, useState } from "react";

import { auth } from "../firebase";

// Contextの型を用意
interface IAuthContext {
  currentUser: User | null | undefined;
}

// Contextを宣言。Contextの中身を {currentUser: undefined} と定義
const AuthContext = createContext<IAuthContext>({
  currentUser: undefined,
});

const AuthProvider = (props: any) => {
  // Contextに持たせるcurrentUserは内部的にはuseStateで管理
  const [currentUser, setCurrentUser] = useState<User | null | undefined>(
    undefined
  );
  useEffect(() => {
    /*
    # WARNING: 次の操作をすると、ローディングが30秒弱表示し続けてしまう問題がある
    # - ログアウトしてすぐにトップにアクセス
    # - ログイン状態でブラウザのキャッシュ、Cookieとサイトデータを削除してトップにアクセス
    #   NOTE: 次の理由により、この問題を抱えたままリリースする
    #    - 改善が難しい
    #    - 特殊な操作が必要で発生率が低いと推測される
    #    - 本事象発生後最終的にログイン画面に遷移するためユーザ操作が継続できることから致命的とはいえない
    # https://github.com/ebisuinc/mit-web-spa/issues/265
    # onAuthStateChangedがタイムアウトするまで処理が停止している
    */
    // Firebase Authのメソッド。ログイン状態が変化すると呼び出される
    auth.onAuthStateChanged(
      (user) => {
        setCurrentUser(user);
      },
      (error) => {
        console.error("Auth state change error:", error);
      }
    );
  }, [currentUser]);
  return (
    <AuthContext.Provider
      value={{
        currentUser: currentUser,
      }}
    >
      {props.children}
    </AuthContext.Provider>
  );
};

export { AuthContext, AuthProvider };
